<template>
  <svg viewBox="0 0 1199 1722" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M611 940c106 0 204-49 204-167 0-73-37-118-110-136v-2c62-20 92-58 92-114 0-106-93-147-186-147-113 0-193 62-197 179h103c2-57 35-96 94-96 45 0 77 24 77 71 0 51-42 72-88 72h-31v82h34c56 0 99 23 99 84 0 58-39 88-95 88-68 0-103-37-107-110H397c2 131 87 196 214 196zm-12-816c292 0 528 236 528 528 0 291-236 528-528 528-291 0-528-237-528-528 0-292 237-528 528-528z" />
  </svg>
</template>
